import { AssertHomey } from '../../../../../util/decorators';

export const card = {
	namespaced: true,

	state: {
		actions: null,
		conditions: null,
		triggers: null,
	},

	getters: {
		triggers(store){
			return store.triggers;
		},
		conditions(store){
			return store.conditions;
		},
		actions(store){
			return store.actions;
		},
	},

	mutations: {
		setTriggerCards(state, { triggers }){
			state.triggers = triggers;
		},
		setConditionCards(state, { conditions }){
			state.conditions = conditions;
		},
		setActionCards(state, { actions }){
			state.actions = actions;
		},
		clearAll(state){
			state.actions = null;
		}
	},

	actions: {
		@AssertHomey()
		retrieveTriggers({ commit, homeyAPI }){
			if (this.retrieveTriggersRequest) {
				console.log('retrieve trigger cards from cache');
				return this.retrieveTriggersRequest;
			}
			console.log('retreive trigger cards!');
			this.retrieveTriggersRequest = homeyAPI.flow.getFlowCardTriggers()
				.then((triggers) => {
					commit('setTriggerCards', { triggers });
					this.retrieveTriggersRequest = null;
				})
				.catch(err => {
					this.retrieveTriggersRequest = null;
					console.error(err);
					return Promise.reject(err);
				});
		},
		@AssertHomey()
		retrieveConditions({ commit, homeyAPI }){
			if (this.retrieveConditionsRequest) {
				console.log('retrieve condition cards from cache');
				return this.retrieveConditionsRequest;
			}
			console.log('retreive condition cards!');
			this.retrieveConditionsRequest = homeyAPI.flow.getFlowCardConditions()
				.then((conditions) => {
					commit('setConditionCards', { conditions });
					this.retrieveConditionsRequest = null;
				})
				.catch(err => {
					this.retrieveConditionsRequest = null;
					console.error(err);
					return Promise.reject(err);
				});
		},
		@AssertHomey()
		retrieveActions({ commit, homeyAPI }){
			if (this.retrieveActionsRequest) {
				console.log('retrieve action cards from cache');
				return this.retrieveActionsRequest;
			}
			console.log('retreive action cards!');
			this.retrieveActionsRequest = homeyAPI.flow.getFlowCardActions()
				.then((actions) => {
					commit('setActionCards', { actions });
					this.retrieveActionsRequest = null;
				})
				.catch(err => {
					this.retrieveActionsRequest = null;
					console.error(err);
					return Promise.reject(err);
				});
		},
		clearAll({ commit }){
			commit('clearAll');
		}
	},

	plugins: [
		// (store) => {
		//   cloudAPI.on('logout', () => store.commit('api/logOut'));
		//   cloudAPI.on('token', (token) => store.commit('api/setToken', { token }));
		//
		//   const { token } = store.state.api;
		//   if (token) {
		//     store.dispatch('api/logIn', { token });
		//   }
		// },
	],
};
